<!--
Copyright (c) 2020 GanttProject Cloud OU.
Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
-->
<template>
    <div class="modal fade" id="modal-new-billing" tabindex="-1" role="dialog"
         aria-labelledby="modal-new-billing-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" @keydown="onKeyboardEvent">
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-new-billing-title">{{ this.isEditing() ? 'Edit Billing Account' : 'New Billing Account'}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="form-group">
                            <label for="modal-new-billing-name">Name</label>
                            <input type="text" class="form-control" id="modal-new-billing-name" placeholder="Account name"
                                   v-model="name">
                        </div>
                        <div class="form-group">
                            <label for="modal-new-billing-desc">Description</label>
                            <textarea class="form-control" id="modal-new-billing-desc" rows="3"
                                      v-model="description"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BtnSubmit :title="this.isEditing() ? 'Update' : 'Create Account'" spinner ref="submitButton" :submitHandler="createBilling">
                    </BtnSubmit>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';
import {handleXhrError, ShortcutHandler} from '../utils/Ui';
import {MeBillingCreate, MeBillingUpdate} from '../Routes';
import {BillingDto} from '../Teams';
import BtnSubmit from './BtnSubmit.vue';

import $ from 'jquery';

@Component({
    components: {BtnSubmit},
})
export default class BillingNewModal extends Vue {

  @Prop()
  public dashboardRefresh: () => void;
  private description: string = '';
  private name = '';
  private billingRefid: string = '';
  private shortcutHandler = new ShortcutHandler();

  public mounted() {
    this.shortcutHandler.register('Enter', this.createBilling);
    $('#modal-new-billing').on('shown.bs.modal', () => $('#modal-new-billing-name').trigger('focus'));
  }

  private createBilling(): JQueryPromise<any> {
    const call: JQueryPromise<any> = (this.billingRefid === '')
        ? MeBillingCreate.invoke({
          name: this.name,
          description: this.description
        })
        : MeBillingUpdate.invoke({
          refid: this.billingRefid,
          name: this.name,
          description: this.description
        })
    return call.then((newBilling: BillingDto) => {
      this.hide();
      this.dashboardRefresh();
      this.billingRefid = '';
      this.name = '';
      this.description = '';
    }).fail((jqXhr) => {
      handleXhrError(jqXhr, 'Failed to create a new billing account');
    })
  }

  private onKeyboardEvent(e: KeyboardEvent) {
    this.shortcutHandler.handle(e);
  }

  private hide() {
    $('#modal-new-billing').modal('hide');
    this.name = '';
    this.description = '';
  }

  public editBilling(billing: BillingDto) {
    this.name = billing.name;
    this.description = billing.description;
    this.billingRefid = billing.refid;
    $('#modal-new-billing').modal('show');
  }

  private isEditing(): boolean { return this.billingRefid !== '' }
}
</script>

